// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"gu5lY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _vue = require("vue");
var _buefy = require("buefy");
var _buefyDefault = parcelHelpers.interopDefault(_buefy);
var _simpleLayoutJs = require("./simple-layout.js");
var _utils = require("./utils");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
if ((0, _utils.isInsideIFrame)()) // If this page is displayed within an IFrame, open the sign-in page in a popup for security reasons
// An external website might for example add a key listener to the iframe content
window.alert("Authentication within an IFrame is forbidden for security reasons. Please use `?display=popup` to trigger authentication in a popup.");
else init();
function init() {
    return __awaiter(this, void 0, void 0, function() {
        function loginIxSSO() {
            return __awaiter(this, void 0, void 0, function() {
                var res, _a, _b;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            // see EAUTH2-16
                            console.log("Signing in using legacy SSO");
                            return [
                                4 /*yield*/ ,
                                fetch("../../bypsauth/auth?streamversion=9.00.000.000&responseformat=byps-json&language=" + locale)
                            ];
                        case 1:
                            res = _c.sent();
                            if (!res.ok) return [
                                3 /*break*/ ,
                                2
                            ];
                            // To resume the redirection flow to the client (possibly code exchange flow)
                            window.location.href = (0, _utils.API_URL) + "/check-roles";
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 2:
                            console.warn("Failed to sign-in with SSO");
                            _b = (_a = window).alert;
                            return [
                                4 /*yield*/ ,
                                res.text()
                            ];
                        case 3:
                            _b.apply(_a, [
                                _c.sent()
                            ]);
                            _c.label = 4;
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
        var _a, status, signInChoices, timezone, locale, messages, app;
        var _b;
        return __generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.all([
                            (0, _utils.fetchJson)((0, _utils.API_URL) + "/status"),
                            (0, _utils.fetchJson)((0, _utils.API_URL) + "/sign-in-choices")
                        ])
                    ];
                case 1:
                    _a = _c.sent(), status = _a[0], signInChoices = _a[1];
                    timezone = (0, _utils.getTimezone)();
                    if (signInChoices.provider) {
                        console.log('Signing in using provider "'.concat(signInChoices.provider));
                        window.location.href = "".concat((0, _utils.API_URL), "/sign-in?provider=").concat(encodeURIComponent(signInChoices.provider), "&timezone=").concat(encodeURIComponent(timezone));
                    }
                    locale = (_b = signInChoices.locale) !== null && _b !== void 0 ? _b : (0, _utils.getDefaultLocale)();
                    return [
                        4 /*yield*/ ,
                        (0, _utils.fetchJson)("./locales/sign-in-".concat(locale, ".json"))
                    ];
                case 2:
                    messages = _c.sent();
                    document.documentElement.lang = locale;
                    if (!(signInChoices.ixSsoEnabled && !signInChoices.enablePasswordLogin && (0, _utils.isEmpty)(signInChoices.providerLabels))) return [
                        3 /*break*/ ,
                        4
                    ];
                    // no other choice than legacy SSO? => trigger it directly
                    return [
                        4 /*yield*/ ,
                        loginIxSSO()
                    ];
                case 3:
                    // no other choice than legacy SSO? => trigger it directly
                    _c.sent();
                    _c.label = 4;
                case 4:
                    app = (0, _vue.createApp)({
                        data: function() {
                            var _a;
                            return {
                                messages: messages,
                                status: status,
                                signInChoices: signInChoices,
                                username: (_a = signInChoices.login_hint) !== null && _a !== void 0 ? _a : "",
                                password: "",
                                changePassword: null,
                                newPassword: "",
                                newPasswordRepeat: "",
                                errorMessage: null,
                                errorMessageSSO: null
                            };
                        },
                        computed: {
                            hasProviders: function() {
                                return !(0, _utils.isEmpty)(this.signInChoices.providerLabels) || this.signInChoices.ixSsoEnabled;
                            }
                        },
                        mounted: function() {
                            if (signInChoices.enablePasswordLogin && !this.hasProviders) // EAUTH2-45: focus on username/password field
                            try {
                                if (signInChoices.login_hint) this.$refs.password.focus();
                                else this.$refs.username.focus();
                            } catch (e) {}
                        },
                        methods: {
                            eloLogin: function() {
                                return __awaiter(this, void 0, void 0, function() {
                                    var username, password, res, json;
                                    var _a, _b, _c;
                                    return __generator(this, function(_d) {
                                        switch(_d.label){
                                            case 0:
                                                this.errorMessage = null;
                                                username = this.username;
                                                password = this.password;
                                                return [
                                                    4 /*yield*/ ,
                                                    fetch((0, _utils.API_URL) + "/elo-login", {
                                                        method: "POST",
                                                        headers: {
                                                            "Accept": "application/json",
                                                            "Content-Type": "application/json"
                                                        },
                                                        body: JSON.stringify({
                                                            username: username,
                                                            password: password,
                                                            timezone: timezone
                                                        })
                                                    })
                                                ];
                                            case 1:
                                                res = _d.sent();
                                                if (!res.ok) return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    res.json()
                                                ];
                                            case 2:
                                                json = _d.sent();
                                                if (json.changePassword === "NO_CHANGE") // To resume the redirection flow to the client (possibly code exchange flow)
                                                window.location.href = (0, _utils.API_URL) + "/check-roles";
                                                else {
                                                    // Currently, a failed login is still passed as OK
                                                    // because failures cannot provide a JSON response with more details
                                                    // since the IX REST Plugin removes any payloads for error responses.
                                                    this.changePassword = json.changePassword;
                                                    this.passwordRules = json.passwordRules;
                                                }
                                                return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                            case 3:
                                                console.warn("Failed to sign-in (".concat(res.statusText, ")"));
                                                if (res.status === 401) this.errorMessage = (_a = messages["error_wrong_credentials"]) !== null && _a !== void 0 ? _a : "Unknown user, incorrect password, or the account is locked.";
                                                else if (res.status === 409) this.errorMessage = (_b = messages["error_password_conflict"]) !== null && _b !== void 0 ? _b : "Conflict: password change required but insufficient rights to do so.";
                                                else this.errorMessage = (_c = messages["error_unexpected"]) !== null && _c !== void 0 ? _c : "Unexpected error, please contact your administrator.";
                                                _d.label = 4;
                                            case 4:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            },
                            signInWith: function(providerId) {
                                window.location.href = "".concat((0, _utils.API_URL), "/sign-in?provider=").concat(encodeURIComponent(providerId), "&timezone=").concat(encodeURIComponent(timezone));
                            },
                            saveNewPassword: function() {
                                return __awaiter(this, void 0, void 0, function() {
                                    var username, password, newPassword, newPasswordRepeat, res;
                                    var _a, _b, _c, _d;
                                    return __generator(this, function(_e) {
                                        switch(_e.label){
                                            case 0:
                                                this.errorMessage = null;
                                                username = this.username;
                                                password = this.password;
                                                newPassword = this.newPassword;
                                                newPasswordRepeat = this.newPasswordRepeat;
                                                return [
                                                    4 /*yield*/ ,
                                                    fetch((0, _utils.API_URL) + "/change-password", {
                                                        method: "POST",
                                                        headers: {
                                                            "Accept": "application/json",
                                                            "Content-Type": "application/json"
                                                        },
                                                        body: JSON.stringify({
                                                            username: username,
                                                            password: password,
                                                            timezone: timezone,
                                                            newPassword: newPassword,
                                                            newPasswordRepeat: newPasswordRepeat
                                                        })
                                                    })
                                                ];
                                            case 1:
                                                res = _e.sent();
                                                if (res.ok) // To resume the redirection flow to the client (possibly code exchange flow)
                                                window.location.href = (0, _utils.API_URL) + "/check-roles";
                                                else {
                                                    console.warn("Failed to change password");
                                                    if (res.status === 401) this.errorMessage = (_a = messages["error_wrong_credentials"]) !== null && _a !== void 0 ? _a : "Unknown user, incorrect password, or the account is locked.";
                                                    else if (res.status === 403) this.errorMessage = (_b = messages["error_new_password_rejected"]) !== null && _b !== void 0 ? _b : "The new password does not match the password policy.";
                                                    else if (res.status === 409) this.errorMessage = (_c = messages["error_password_conflict"]) !== null && _c !== void 0 ? _c : "Conflict: password change required but insufficient rights to do so.";
                                                    else this.errorMessage = (_d = messages["error_unexpected"]) !== null && _d !== void 0 ? _d : "Unexpected error, please contact your administrator.";
                                                }
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            },
                            skipChangePassword: function() {
                                return __awaiter(this, void 0, void 0, function() {
                                    return __generator(this, function(_a) {
                                        // To resume the redirection flow to the client (possibly code exchange flow)
                                        window.location.href = (0, _utils.API_URL) + "/check-roles";
                                        return [
                                            2 /*return*/ 
                                        ];
                                    });
                                });
                            },
                            loginIxSSO: loginIxSSO
                        }
                    });
                    app.use((0, _buefyDefault.default), (0, _utils.buefyConfig));
                    app.mount("#app");
                    console.log("Auth2 - Sign-in page loaded");
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}

},{"vue":"dylud","buefy":"czVrE","./simple-layout.js":"3vUnS","./utils":"13wIX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3vUnS":[function(require,module,exports) {
// This is based on the assumption that all views are at pages under "plugin/auth2/*"
var _eloUiCss = require("@elo/ui-buefy-v3/dist/elo-ui.css");
var _fontEloSansPro = require("@elo/font-elo-sans-pro");
var _signInCss = require("../css/sign-in.css");
var _eIconsCss = require("../css/e-icons.css");
var _utils = require("./utils"); // EAUTH2-33
document.body.style.backgroundImage = "url('".concat((0, _utils.API_URL), "/branding/background')");

},{"@elo/ui-buefy-v3/dist/elo-ui.css":"81LGK","@elo/font-elo-sans-pro":"omINW","../css/sign-in.css":"anbT2","../css/e-icons.css":"fLMWM","./utils":"13wIX"}],"81LGK":[function() {},{}],"omINW":[function() {},{}],"anbT2":[function() {},{}],"fLMWM":[function() {},{}]},["gu5lY"], "gu5lY", "parcelRequiree3ab")

//# sourceMappingURL=sign-in.b78b4086.js.map
